import { Injectable } from '@angular/core';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { MissionStatementMessages } from '../locale/mission-statement.messages';
import { CreateMissionStatement } from '../model/create-mission-statement.model';
import { MissionStatement } from '../model/mission-statement.model';
import { MissionStatementAPIService } from './mission-statement-api.service';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

// Single-slot guard: the mission statement is a company singleton, so all writes share one key. A
// duplicate write while one is in flight is coalesced onto the same promise (see InFlightRegistry).
const WRITE_KEY = 'write';

@Injectable({
  providedIn: 'root'
})
export class MissionStatementBusinessService {

  private updating: InFlightRegistry;

  constructor(
    private missionAPI: MissionStatementAPIService,
    private notifyUtils: NotifyUtils
  ) {
    this.updating = new InFlightRegistry();
  }

  get(): Observable<MissionStatement> {
    return this.missionAPI.getMission();
  }

  set(missionStatement: CreateMissionStatement): Promise<MissionStatement> {
    return this.updating.run(WRITE_KEY, () =>
      firstValueFrom(this.missionAPI.setMission(missionStatement))
        .then(res => {
          this.notifyUtils.notify(MissionStatementMessages.SUCCESS_SET_MISSION);
          return res;
        })
    );
  }

  delete(): Promise<MissionStatement> {
    return this.updating.run(WRITE_KEY, () =>
      firstValueFrom(this.missionAPI.deleteMission())
        .then(res => {
          this.notifyUtils.notify(MissionStatementMessages.SUCCESS_DELETE_MISSION);
          return res;
        })
    );
  }
}
